import { Persona, PersonaSize, TooltipHost } from "@fluentui/react";
import React from "react";
import { formatDateStringWithTime } from "utils/utils";

// the backend stores the Flottomat business case time in UTC and serializes it without an offset
const asUtcDateString = (date: string) =>
  /Z$|[+-]\d{2}:\d{2}$/.test(date) ? date : date + "Z";

/**
 * User tag of the person who executed the Flottomat AmendRiskExecute request: the tooltip shows the user
 * (full name, otherwise e-mail, otherwise user id - same fallback as the user tags in the fleet details tables)
 * and the local date and time of the request.
 */
const FlottomatBusinessCaseUserTag = ({ vehicle }: { vehicle: any }) => {
  const user =
    vehicle?.flottomatBusinessCaseCreatedByUserName ||
    vehicle?.flottomatBusinessCaseCreatedByUserEmail ||
    vehicle?.flottomatBusinessCaseCreatedByUserId;

  return (
    <TooltipHost
      content={
        <>
          <div>{user}</div>
          {vehicle?.flottomatBusinessCaseCreatedAt && (
            <div>
              {formatDateStringWithTime(
                asUtcDateString(vehicle.flottomatBusinessCaseCreatedAt)
              )}
            </div>
          )}
        </>
      }
    >
      <Persona text={user} hidePersonaDetails size={PersonaSize.size24} />
    </TooltipHost>
  );
};

export default FlottomatBusinessCaseUserTag;
